import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../store/auth-actions';
import classes from './Header.module.css';
// import Search from './Search'
import UserInfo from './UserInfo'
import Messages from './Messages'
import FAQ from './FAQ'
import Support from './Support';
import useClickOutside from '../../hooks/useClickOutside';
import { usersApi, messagesApi } from '../../utils'
import { ObjectTypeNamesEnum } from '../../models/ObjectTypeEnum'
import { throwApiError } from "../lms-shared/store/error-handling-actions";
import iconUser from '../../assests/header/icon-user.png'
import UserProfile from '../lms-shared/UI/UserProfile';
import ChangeUserProfilePopup from './ChangeUserProfilePopup';
import { useLocation, useNavigate } from 'react-router-dom';
import * as PathRouter from '../../models/PathRoute'
import * as ideWrapper from "../lms-shared/ide-wrapper";
import { onKeyDown } from '../../service';
import DynamicMessage from '../lms-shared/UI/Popups/DynamicMessage/DynamicMessage';
import { DynamicMessageTypeEnum } from '../lms-shared/models/DynamicMessageTypeEnum';

const Header = () => {
    const { user, isAuthenticated } = useSelector(state => state.auth);
    const { lang, texts } = useSelector(state => state.translate);
    const { portalUrl, logo, homeUrl, applicationId } = useSelector((state) => state.application);
    const uiData = useSelector((state) => state.general.uiData);

    const [showUserInfo, setShowUserInfo] = useState(false)
    const [showMessages, setShowMessages] = useState(false)
    const [showSupport, setShowSupport] = useState(false)
    const [showFAQ, setShowFAQ] = useState(false)
    const [messages, setMessages] = useState({})
    const [messagePopup, setMessagesPopup] = useState(null)
    const [unReadMessages, setUnReadMessages] = useState({})
    const [userInfo, setUserInfo] = useState([])
    const [showChangeUserProfile, setShowChangeUserProfile] = useState(false)
    const navigate = useNavigate()
    const location = useLocation()

    const dispatch = useDispatch();

    const popupRef = useRef(null);

    useClickOutside(popupRef, () => {
        // לא למחוק את הסוגריים
        // העברת הפונקציה כאוביקט בגלל הcallback
        {
            setShowMessages((prevShowMessages) => {
                if (prevShowMessages) {
                    setToRead()
                    setUnReadMessages(0)
                }
                return false
            })
        }
        setShowUserInfo(false);
        setShowFAQ(false);
        setShowSupport(false)
    });

    useEffect(() => {
        if (uiData.bannerMessageTypeId && applicationId) {
            async function fetchMessages() {
                const messagesRangeFilter = {
                    refObjectId: applicationId,
                    refObjectType: ObjectTypeNamesEnum.Application,
                    lang: lang,
                    targetObjects: [
                        { type: ObjectTypeNamesEnum.User },
                        { type: ObjectTypeNamesEnum.ConstUserGroup },
                    ],
                    ignoreMessageTypesIds: [uiData.bannerMessageTypeId]
                }
                messagesApi.messagesFilterRangePost({ messagesRangeFilter }, (error, resdata, response) => {
                    if (error) {
                        dispatch(throwApiError({ userMessage: texts.MessageContentMessagesFilterRange, error: error, statusCode: response?.statusCode, message: "messagesFilterRangePost " + error.message, level: 1, component: "Header", line: 68 }))
                    } else {
                        // sort by date
                        resdata.sort((a, b) => new Date(b.sentDate) - new Date(a.sentDate))

                        setMessages(resdata.map(m => {
                            // parse contents message to dict with lang keys
                            const parsecontents = m.contents?.reduce((obj, c) => { obj[c.lang] = c.content && JSON.parse(c.content); return obj }, {});
                            m.contents = parsecontents;
                            return m;
                        }))
                        setUnReadMessages(resdata.filter(m => m.isRead === false).length)
                    }
                })
            }
            if (lang)
                fetchMessages();
        }
    }, [lang, uiData, applicationId]);

    useEffect(() => {
        async function getUsersSchools() {
            usersApi.usersFilterSchoolsRangePost((error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.schoolsFilterError, error: error, statusCode: response?.statusCode, message: "usersFilterSchoolsRangePost " + error.message, level: 1, component: "Header", line: 86 }))

                } else {
                    setUserInfo(resdata.map(s => s.name))
                }
            })
        }
        getUsersSchools()
    }, [])

    function setToRead() {
        setMessages((prevMessages) => {
            const newMessages = [...prevMessages]
            if (newMessages.length > 0) {
                let messagesIds = []
                newMessages.forEach(m => {
                    if (!m.isRead) {
                        messagesIds.push(m.id)
                        m.isRead = true
                    }
                });
                const messageSetReadRangeInput = {
                    messagesIds: messagesIds
                }
                messagesApi.messagesSetReadRangePost({ messageSetReadRangeInput }, (error, resdata, response) => {
                    if (error) {
                        dispatch(throwApiError({ userMessage: texts.MessageContentMessagesSetReadRange, error: error, statusCode: response?.statusCode, message: "messagesSetReadRangePost " + error.message, level: 1, component: "Header", line: 113 }))
                    }
                })
            }
            return newMessages
        })
    }

    function showFAQFunc(e) {
        e.stopPropagation();
        setShowFAQ((prevShowFAQ) => !prevShowFAQ);
        if (showSupport)
            setShowSupport(false)
        if (showMessages)
            setShowMessages(false)
    }

    function showSupportFunc(e) {
        e.stopPropagation();
        setShowSupport((prevShowSupport) => !prevShowSupport);
        if (showMessages)
            setShowMessages(false)
        if (showFAQ)
            setShowFAQ(false)
    }
    function showMessagesFunc(e) {
        e.stopPropagation();
        setShowMessages((prevShowMessages) => {
            if (prevShowMessages) {
                setToRead()
                setUnReadMessages(0)
            }
            return !prevShowMessages
        })
        if (showSupport)
            setShowSupport(false)
        if (showFAQ)
            setShowFAQ(false)

    }
    function showUserInfoFunc(e) {
        e.stopPropagation();
        setShowUserInfo((prevShowUserInfo) => !prevShowUserInfo)
    }

    function goBackWithoutSave() {
        setMessagesPopup(null)
        navigate(homeUrl)
    }

    function logoBtnClic() {
        const locationSplit = location.pathname.split('/')
        if (`/${locationSplit[1]}` === homeUrl && locationSplit[2] === PathRouter.PROJECT) {
            ideWrapper.requestChangesProject((changed) => {
                if (changed == true) {
                    setMessagesPopup(<DynamicMessage
                        type={DynamicMessageTypeEnum.Warn}
                        title={texts.notSavedProject}
                        content={texts.messageContentSaveProjectAndExit}
                        cancelFunc={() => setMessagesPopup(null)}
                        confirmText={texts.save}
                        confirmFunc={() => setMessagesPopup(null)}
                        otherText={texts.exitWithoutSaving}
                        otherFunc={goBackWithoutSave}
                        customWidth='430px' />)
                }
                else {
                    setMessagesPopup(<DynamicMessage
                        type={DynamicMessageTypeEnum.Warn}
                        title={texts.exitIde}
                        cancelFunc={() => setMessagesPopup(null)}
                        confirmText={texts.exit}
                        confirmFunc={goBackWithoutSave} />)
                }
            })

        }


        else
            navigate(homeUrl)
    }

    return (
        <>
            <header>
                <div className={`${classes.Header} ${window.location.pathname.split('/')?.length === 3 ? classes.ColoredHeader : ''}`}>
                    <div className={classes.Logos}>
                        <a className={classes.HomeIcon} href={`${process.env.PUBLIC_URL}${homeUrl}`}></a>
                        <div className={`${classes.EduLogo} ${classes.Logo}`}></div>
                        <a className={`${classes.SkillzLogo} ${classes.Logo}`} href={`${process.env.PUBLIC_URL}${homeUrl}`}></a>
                        {homeUrl !== window.location.pathname &&
                            <button className={classes.SystemIcon} style={{ backgroundImage: `url(${logo})` }} onClick={logoBtnClic}></button>}
                    </div>
                    {/* <div className={classes.WrapSearchAndCourseList}>
                    <Search></Search>
                    <div className={classes.CourseListTemp}>{texts.headerRedirectCourse}</div>
                </div> */}
                    {isAuthenticated ?
                        <div className={classes.User} onClick={(e) => showUserInfoFunc(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, showUserInfoFunc)}>
                            <UserProfile width="37px"
                                image={user.profileImage ?
                                    `${user.profileImage}` :
                                    iconUser}
                            />
                            <div className={classes.UserName}>{user.firstName} {user.lastName}</div>
                            {showUserInfo && <UserInfo userInfo={userInfo} openEdit={() => setShowChangeUserProfile(true)} />}
                        </div>
                        :
                        <div className={classes.UserName} onClick={login}>{texts.headerLogin}</div>
                    }
                    <div className={classes.Btns}>
                        <div className={classes.UnReadMessagesContainer}>
                            {unReadMessages > 0 ? <div className={classes.UnReadMessages}>{unReadMessages}</div> : <></>}
                            <div className={`${classes.Btn} ${classes.Alerts}`} onClick={(e) => showMessagesFunc(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, showMessagesFunc)}></div>
                        </div>

                        <div className={`${classes.Btn} ${classes.FAQ}`} onClick={(e) => showFAQFunc(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, showFAQFunc)}></div>
                        <div className={`${classes.Btn} ${classes.Support}`} onClick={(e) => showSupportFunc(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, showSupportFunc)}></div>
                    </div>
                </div>
                <div className={`${classes.Popup} ${showMessages ? classes.ShowMessages : showSupport ? classes.ShowSupport : showFAQ ? classes.ShowFAQ : ''}`} ref={popupRef}>
                    {showMessages && <Messages messages={messages} />}
                    {showFAQ && <FAQ setShowFAQ={setShowFAQ} />}
                    {showSupport && <Support setShowSupport={setShowSupport} />}
                    {showChangeUserProfile && <ChangeUserProfilePopup closePopup={() => setShowChangeUserProfile(false)} />}
                </div>
            </header>
            {messagePopup}
        </>
    )
}

export default Header;